module.exports = __webpack_public_path__ + "img/reference55.8ed2eafb.jpg";